import PetitionBreadcrumbs from "@/modules/petition/pages/PetitionBreadcrumbs.vue";
import ApplicationDiss from "@/modules/petition/pages/ApplicationDiss.vue";
import ListDiss from "@/modules/petition/pages/ListDiss.vue";
import Council from "@/modules/petition/pages/council/Council";
import DetailApplication from "@/modules/petition/pages/DetailApplication";
import DetailCouncil from "@/modules/petition/pages/DetailCouncil";
import urls from "./urls";

const account = String(process.env.VUE_APP_ACCOUNTS_PREFIX).replace('/', '');
const organization = String(process.env.VUE_APP_ORGANIZATION_PREFIX).replace('/', '');

export default ([

  {
    path: '/petition',
    name: 'PetitionBreadcrumbs',
    redirect: {name: 'ApplicationDiss'},
    component: PetitionBreadcrumbs,
    meta: {
      breadcrumb: 'Ходательства',
      requiredAuth: true,
      instances: [
        account,
        organization,
        process.env.VUE_APP_DISS_PREFIX,
      ]
    },

    children: [
      {
        path: '/petition/my',
        name: 'ApplicationDiss',
        component: ApplicationDiss,
        meta: {
          requiredAuth: true,
          instances: [
            account,
            organization,
            process.env.VUE_APP_DISS_PREFIX,
          ],
          breadcrumb: 'Подать ходательство',

        },
      },
      {
        path: '/petition/council',
        name: 'Council',
        component: Council,
        meta: {
          requiredAuth: true,
          instances: [
            account,
            organization,
            process.env.VUE_APP_DISS_PREFIX,
          ],
          breadcrumb: 'Подать на создание',

        },
      },
      {
        path: '/petition/list',
        name: 'ListDiss',
        component: ListDiss,
        meta: {
          requiredAuth: true,
          instances: [
            account,
            organization,
            process.env.VUE_APP_DISS_PREFIX,
          ],
          breadcrumb: 'Список заявок',

        },
        children: [
          {
            path: '/petition/list/:id([0-9]+)/',
            name: 'DetailApplication',
            component: DetailApplication,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Заявка',
              instances: [
                organization,
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
          {
            path: '/petition/council/:id([0-9]+)/',
            name: 'DetailCouncil',
            component: DetailCouncil,
            meta: {
              requiredAuth: true,
              breadcrumb: 'Заявка',
              instances: [
                organization,
                process.env.VUE_APP_DISS_PREFIX,
              ]
            },
          },
        ]
      },
    ],

  },


])


